/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateOrUpdateLabelCommand } from '../models/create-or-update-label-command';
import { LabelData } from '../models/label-data';
import { RemoveLabelCommand } from '../models/remove-label-command';

@Injectable({
  providedIn: 'root',
})
export class LabelsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation labelsGet
   */
  static readonly LabelsGetPath = '/api/Labels/Get';

  /**
   * Címkek lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labelsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsGet$Plain$Response(params?: {
    Search?: string;
    ShowInactive?: boolean;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<LabelData>>> {

    const rb = new RequestBuilder(this.rootUrl, LabelsService.LabelsGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
      rb.query('ShowInactive', params.ShowInactive, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LabelData>>;
      })
    );
  }

  /**
   * Címkek lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labelsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsGet$Plain(params?: {
    Search?: string;
    ShowInactive?: boolean;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<LabelData>> {

    return this.labelsGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<LabelData>>) => r.body as Array<LabelData>)
    );
  }

  /**
   * Címkek lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labelsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsGet$Response(params?: {
    Search?: string;
    ShowInactive?: boolean;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<LabelData>>> {

    const rb = new RequestBuilder(this.rootUrl, LabelsService.LabelsGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
      rb.query('ShowInactive', params.ShowInactive, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LabelData>>;
      })
    );
  }

  /**
   * Címkek lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labelsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsGet(params?: {
    Search?: string;
    ShowInactive?: boolean;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<LabelData>> {

    return this.labelsGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<LabelData>>) => r.body as Array<LabelData>)
    );
  }

  /**
   * Path part for operation labelsPost
   */
  static readonly LabelsPostPath = '/api/Labels/Post/Post';

  /**
   * Címke létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labelsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  labelsPost$Response(params?: {
    body?: CreateOrUpdateLabelCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, LabelsService.LabelsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Címke létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labelsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  labelsPost(params?: {
    body?: CreateOrUpdateLabelCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.labelsPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation labelsRemove
   */
  static readonly LabelsRemovePath = '/api/Labels/Remove/Remove';

  /**
   * Címke törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labelsRemove()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  labelsRemove$Response(params?: {
    body?: RemoveLabelCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, LabelsService.LabelsRemovePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Címke törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labelsRemove$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  labelsRemove(params?: {
    body?: RemoveLabelCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.labelsRemove$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation labelsCsv
   */
  static readonly LabelsCsvPath = '/api/Labels/Csv';

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labelsCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsCsv$Plain$Response(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, LabelsService.LabelsCsvPath, 'get');
    if (params) {
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labelsCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsCsv$Plain(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.labelsCsv$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `labelsCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsCsv$Response(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, LabelsService.LabelsCsvPath, 'get');
    if (params) {
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `labelsCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  labelsCsv(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.labelsCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
